import { render, staticRenderFns } from "./DayOfWeek.vue?vue&type=template&id=798f9b01&scoped=true&"
import script from "./DayOfWeek.vue?vue&type=script&lang=ts&"
export * from "./DayOfWeek.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798f9b01",
  null
  
)

export default component.exports